export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14804.cc032c67.jpg";